"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();

import { useEffect } from "react"
import * as Sentry from "@sentry/nextjs"

type AppError = Error & { digest?: string }

export default function GlobalError({
  error,
  reset,
}: {
  error: AppError
  reset: () => void
}) {
  useEffect(() => {
    const digest = error.digest
    Sentry.captureException(error, {
      tags: {
        error_boundary: "global",
        ...(digest ? { digest: String(digest) } : {}),
      },
    })
  }, [error])

  return (
    <html lang="en">
      <body className="antialiased">
        <div className="mx-auto flex min-h-screen max-w-lg flex-col items-center justify-center gap-4 px-4">
          <h1 className="text-xl font-semibold text-gray-900">
            Something went wrong
          </h1>
          <p className="text-center text-gray-600">
            Please try again. If the problem continues, contact support.
          </p>
          <button
            type="button"
            onClick={() => reset()}
            className="rounded bg-[#092c3c] px-4 py-2 text-white hover:opacity-90"
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  )
}
